module.exports = __webpack_public_path__ + "static/media/p4.4979bea1.png";